<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>会计报表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText">
				</el-input>
            </div>
            <el-tree
			  :data="dataSource"
			  show-checkbox
			  node-key="id"
			  :expand-on-click-node="false"
			  :show-checkbox="false"
			  :filter-node-method="filterNode"
			  :default-expand-all="true"
			  style="border:1px solid #eee; margin-top:20px;width:100%;"
			  ref = "tree"
			>
			<template #default="{ node, data }">
				<span class="custom-tree-node">
					<span>{{ node.label }}</span>
					<span>
						<el-button
                            type="text"
                            icon="el-icon-lx-add"
                            @click="append(node, data)"
							v-if="node.level == 1"
                        >新增</el-button>
						<el-button
                            type="text"
                            icon="el-icon-lx-edit"
                            @click="edit(node, data)"
							v-if="node.level == 2"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="remove(node, data)"
							v-if="node.level == 2"
                        >删除</el-button>
					</span>
				</span>
			</template>
			</el-tree>
        </div>
		
		<!-- 编辑模板弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editTemplateVisible" width="50%">
            <el-form ref="templateForm" :model="templateForm" label-width="120px" :rules="templateRules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="名称" prop="name">
							<el-input v-model="templateForm.name"></el-input>
						</el-form-item>
						<el-form-item label="输出模板" prop="template">
							<el-input v-model="templateForm.template"></el-input>
						</el-form-item>
						<el-form-item label="排序" prop="sortNum">
							 <el-input-number v-model="templateForm.sortNum" :min="1" :max="100"></el-input-number>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="模板内容" name="contentTab">
						<el-form-item label="内容" prop="content">
							<el-input type=textarea :rows=20 v-model="templateForm.content"> </el-input>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editTemplateVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditTemplate" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getAccountingReportConfigTree, deleteAccountingReportTemplate, 
saveAccountingReportTemplate, getAccountingReportTemplate} from '../../../api/index';
export default {
    name: 'accounting_report',
    data() {
        return {
            dataSource: [],
            editVisible: false,
            form: {},
			title:"",
			rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
            },
			templateRules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				template: [{ required: true, message:'请输入模板名称', trigger: 'blur' }],
				sortNum: [{ required: true, message:'请输入排序编号', trigger: 'blur' }],
				content: [{ required: true, message:'请输入模板内容', trigger: 'blur' }],
            },
			previewData:{},
			previewVisible:false,
			fileList:[],
			filterText:"",
			editTemplateVisible:false,
			templateForm:{},
			activeName:"baseTab"
        };
    },
    created() {
        this.getData();
    },
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
    },
    methods: {
		//节点过滤
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
        // 获取树形结构数据
        getData() {
            getAccountingReportConfigTree(this.query).then(res => { 
				if (res.code == 0 ) {
					this.dataSource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 删除操作
        remove(node, data) {
            // 二次确认删除
            this.$confirm('确定要删除 ' + node.label + ' 吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let result = node.level == 1? deleteAccountingReportConfig([data.id]):deleteAccountingReportTemplate([data.id])
					result.then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							const parent = node.parent;
							const children = parent.data.children || parent.data;
							const index = children.findIndex((d) => d.id === data.id);
							children.splice(index, 1);
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//保存模板
		saveEditTemplate() {
			this.$refs.templateForm.validate(valid => {
				if (valid) {
					saveAccountingReportTemplate(this.templateForm).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editTemplateVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		//添加节点
		append(node, data) {
			this.templateForm = {};
			this.templateForm["reportConfigId"] = data.id;
			this.title = "添加报表模板";
			this.activeName = "baseTab";
			this.editTemplateVisible = true;
		},
		//编辑节点
		edit(node, data) {
			if (node.level == 1) {
				getAccountingReportConfig(data.id).then(res=> {
					if (res.code == 0) {
						this.form = res.data;
						this.editVisible = true;
					} else {
						this.$message.error(`获取报表失败！` + res.message);
					}
				});
			} else {
				getAccountingReportTemplate(data.id).then(res=> {
					if (res.code == 0) {
						this.templateForm = res.data;
						this.editTemplateVisible = true;
					} else {
						this.$message.error(`获取报表模板失败！` + res.message);
					}
				});
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>

